import { ca } from '@cian/analytics';

import { adAnalyticsCategory } from '../../../scripts/services/analytics.service';

export const trackAuctionIncreaseModalShow = () => {
  ca('event', {
    name: 'oldevent',
    category: adAnalyticsCategory, // 'New_ad' | 'Edit_ad'
    action: 'auction_popup',
    label: 'standart_show',
  });
};

export const trackAuctionIncreaseModalClose = (type, bet) => {
  ca('event', {
    name: 'oldevent',
    category: adAnalyticsCategory, // 'New_ad' | 'Edit_ad'
    action: 'auction_popup',
    label: `standart_${type}/${bet}`,
  });
};
